export class Account {
  constructor(params = {}) {
    this.id = params.id;
    this.trialName = params.trialName;
    this.companyName = params.companyName;
    this.createdAt = params.createdAt;
    this.sitesEnabled = params.sitesEnabled;
  }
}
